
import * as Core from '@skylab-shared/core';
import { RepositoryResponseConflictCodes, ResponseConflictObject } from '@skylab-shared/core';
import { PrintingPatternModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@Core.BO({ modelType: PrintingPatternModel })
export class PrintingPatternBO extends Core.BusinessObjectBase<PrintingPatternModel> {

    public constructor(
        weaver: Core.Weaver,
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.readonly.addRule(
            [[PrintingPatternModel, 'kind']],
            ctx => ctx.source.isPersistent
        );
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation) && sameValues(conflict.objectProperties!, ['name'])) {
            this.addExternalRuleViolations({
                [this.model.sun]: [{
                    property: 'name',
                    violation: new Core.NonUniqueModelDataError('business.printing-pattern.validation.name.server-rule-violations.non-unique-model-data-error')
                }]
            });
        }
    }
}
